import { useMemo, useState } from 'react';
import { useAudit, useProjectId } from '../data';
import { PageHead } from '../layout';
import { Btn, ErrorBox, Loading, Select } from '../ui/kit';
import { AuditTimeline } from '../ui/history';
import { normalize } from '../format';
import { downloadCsv } from '../importer';
import { fmtDateTime } from '../format';

const TABLE_LABEL: Record<string, string> = { projects: 'Projeto', project_members: 'Equipe', disciplines: 'Disciplinas', wbs_nodes: 'EAP', activities: 'Atividades', baselines: 'Linhas de base', calendar_exceptions: 'Calendário' };

export function AuditPage() {
  const id = useProjectId(); const q = useAudit(id);
  const [table, setTable] = useState<string | null>(null); const [text, setText] = useState('');
  const rows = useMemo(() => (q.data ?? []).filter(r => (!table || r.tableName === table) && (!text.trim() || normalize(`${r.userName} ${r.operation} ${r.recordLabel} ${r.reason}`).includes(normalize(text.trim())))), [q.data, table, text]);
  return (
    <>
      <PageHead eyebrow="Projeto" title="Auditoria" sub="Trilha imutável de quem fez o quê e quando, com valor anterior e novo. Mostra os 200 registros mais recentes.">
        <Btn className="btn" why={!rows.length && 'Não há registros para exportar.'} onClick={() => downloadCsv('auditoria.csv', [['Data e hora', 'Usuário', 'Área', 'Operação', 'Registro', 'Justificativa', 'Alterações'], ...rows.map(r => [fmtDateTime(r.at), r.userName ?? '', TABLE_LABEL[r.tableName] ?? r.tableName, r.operation, r.recordLabel ?? '', r.reason ?? '', r.changes.map(c => `${c.campo}: ${JSON.stringify(c.de)} > ${JSON.stringify(c.para)}`).join(' | ')])])}>Exportar CSV</Btn>
      </PageHead>
      <div className="filters">
        <input className="input search" placeholder="Buscar por pessoa, operação ou registro..." aria-label="Buscar" value={text} onChange={e => setText(e.target.value)} />
        <Select aria-label="Área" value={table} onChange={setTable} empty="Todas as áreas" options={Object.entries(TABLE_LABEL).map(([value, label]) => ({ value, label }))} />
      </div>
      <div className="panel"><div className="panel-body">{q.isLoading ? <Loading /> : q.error ? <ErrorBox error={q.error} /> : <AuditTimeline rows={rows} />}</div></div>
    </>
  );
}
